import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: isScrolled ? '#3d4f3d' : 'transparent',
        borderBottom: isScrolled ? '1px solid rgba(212, 197, 160, 0.3)' : 'none',
        boxShadow: isScrolled ? '0 2px 8px rgba(0,0,0,0.1)' : 'none'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center h-20">
          <div className="hidden md:flex space-x-12">
            <Link
              to="/"
              className="text-xl font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.1em',
                textDecoration: location.pathname === '/' ? 'underline' : 'none',
                textUnderlineOffset: '4px'
              }}
            >
              HOME
            </Link>
            <Link
              to="/about"
              className="text-xl font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.1em',
                textDecoration: location.pathname === '/about' ? 'underline' : 'none',
                textUnderlineOffset: '4px'
              }}
            >
              ABOUT
            </Link>
            <Link
              to="/rsvp"
              className="text-xl font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.1em',
                textDecoration: location.pathname === '/rsvp' ? 'underline' : 'none',
                textUnderlineOffset: '4px'
              }}
            >
              RSVP
            </Link>
            {/* Gallery - hidden until ready to reveal */}
            {/* <Link
              to="/gallery"
              className="text-xl font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.1em',
                textDecoration: location.pathname === '/gallery' ? 'underline' : 'none',
                textUnderlineOffset: '4px'
              }}
            >
              GALLERY
            </Link> */}
          </div>
          
          {/* Mobile menu - simplified for now */}
          <div className="md:hidden flex space-x-6">
            <Link
              to="/"
              className="text-lg font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.05em'
              }}
            >
              HOME
            </Link>
            <Link
              to="/about"
              className="text-lg font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.05em'
              }}
            >
              ABOUT
            </Link>
            <Link
              to="/rsvp"
              className="text-lg font-semibold transition-all duration-200 hover:opacity-70"
              style={{
                color: '#d4c5a0',
                fontFamily: 'Cinzel',
                letterSpacing: '0.05em'
              }}
            >
              RSVP
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}